import { render } from "./CreateProductGroupDescModal.vue?vue&type=template&id=840949a0&scoped=true"
import script from "./CreateProductGroupDescModal.vue?vue&type=script&lang=js"
export * from "./CreateProductGroupDescModal.vue?vue&type=script&lang=js"

import "./CreateProductGroupDescModal.vue?vue&type=style&index=0&id=840949a0&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-840949a0"]])

export default __exports__